import React, { useState } from "react"
import { useEffectOnce, useKeyPressEvent } from "react-use"

import { Step, StepLabel, Stepper } from "@material-ui/core"
import { Alert, AlertTitle } from "@material-ui/lab"

import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import Papers from "Components/UI/Molecules/Papers/PaperList"
import DialogComponent from "Components/UI/Molecules/Modals/DialogComponent"
import CancelConfirmButtons from "Components/UI/Molecules/CancelConfirmButtons"
import InputsWithoutValidate from "Components/UI/Molecules/InputsWithoutValidate"
import Step2 from "Components/UI/Organisms/Plant/Station/New/Fields/Step2"
import Step4 from "Components/UI/Organisms/Plant/Station/New/Fields/Step4"
import LoadSteps from "Components/UI/Organisms/Plant/Used/NewUsed/LoadSteps"
import {
  FORM_VEHICLE,
  TECHNICAL_DATA,
} from "Components/UI/Organisms/Plant/Station/New/Fields"
import { interfaces } from "service/interfaces"

const NewStation = (props) => {
  const { open, handleclose, setRender, render, initialCode = "" } = props
  const createDismissableSnackbar = useCustomSnackbar()

  const [code, setCode] = useState({
    code: initialCode,
  })
  const [initValues, setInitValues] = useState({
    products: [],
    calidades: [],
    vehicle: null,
    originalVehicle: {}
  })
  const [step, setStep] = useState(0)
  const [tab, setTab] = useState(0)
  const [loadingSearch, setLoadingSearch] = useState(false)
  const [warning, setWarning] = useState(false)
  const [productsCheck, setProductsCheck] = useState([])
  const [productsWithOutCheck, setProductsWithOutCheck] = useState([])

  const updateState = () => {
    setStep((oldStep) => oldStep + 1)
  }

  useEffectOnce(() => {
    if (initialCode) {
      handleSubmitCode(initialCode)
    }
  })

  const steps = ["Vehículo", "Datos técnicos", "Productos", "Resumen", ""]

  const horizontalTabs = [
    {
      id: 0,
      title: "Inicio",
      color: "primary",
    },
    {
      id: 1,
      title: "Archivos",
      color: "primary",
    },
    {
      id: 2,
      title: "Historial",
      color: "primary",
    },
  ]

  const handleChange = (name, value) => {
    setInitValues({
      ...initValues,
      vehicle: {
        ...initValues.vehicle,
        [name]: value,
      },
    })
  }

  const confirmSteps = () => {
    return [
      { step: 1, label: "Creando piezas en el stock" },
      ...initValues.products
        .filter((e) => e.checked === true && e.foto)
        .map((row, index) => {
          return {
            step: index + 2,
            label: `Subiendo ${row.producto}`,
          }
        }),
    ]
  }

  const _renderForms = (index) => {
    switch (index) {
      case 0:
        return (
          <>
            {warning && (
              <Alert severity="warning" onClose={() => setWarning(false)}>
                <AlertTitle>Atención!</AlertTitle>
                Este vehiculo <strong>posee piezas en stock!</strong> Revise que
                piezas existen para evitar duplicados!
              </Alert>
            )}
            <InputsWithoutValidate
              fields={FORM_VEHICLE(
                initValues,
                handleSubmitCode,
                handleChangeCode,
                code,
                loadingSearch
              )}
              spacing={3}
            />
          </>
        )
      case 1:
        return (
          <InputsWithoutValidate
            fields={TECHNICAL_DATA(initValues, handleChange)}
            spacing={3}
          />
        )
      // PRODUCTOS
      case 2:
        return (
          <Papers
            height="550px"
            children={
              <Step2 initValues={initValues} setInitValues={setInitValues} />
            }
          />
        )
      // RESUMEN
      case 3:
        return <Step4 initValues={initValues} handleChange={handleChange} setInitValues={setInitValues} productsCheck={productsCheck} productsWithOutCheck={productsWithOutCheck} />
      case 4:
        return <LoadSteps step={step} steps={confirmSteps()} updateState={updateState} /> // elminar updateState !!!!!!!!!
      default:
        break
    }
  }

  useKeyPressEvent("Enter", () => (!disabledSubmit() ? handleSubmit() : null))

  // async function handleUploadImg(empresa, codigo, fotos) {
  //   updateState()
  //   await interfaces.plantStation
  //     .uploadPhoto(empresa, codigo, fotos)
  //     .then(() => {})
  //     .catch((error) => {
  //       createDismissableSnackbar(error.response.data.data, {
  //         variant: "error",
  //       })
  //     })
  // }

  const getNewPhotos = (current = [], original = []) => {
  return current.filter((foto) => !original.includes(foto))
}

  async function handleCreateStock() {
    const previouslyCheckedNowUnselected = initValues.products.filter(
      (p) => productsCheck.includes(p.id) && !p.checked
    )
    const newProductsToCreate = initValues.products.filter(
      (p) => p.checked && productsWithOutCheck.includes(p.id)
    )
    const modifiedProducts = initValues.products
      .filter((p) => productsCheck.includes(p.id))
      .map((p) => {
        const originalItems = p.itemsOriginal || []
        const currentItems = p.items || []

        const added = currentItems.filter((curr) => !curr.stock_id)
        const removed = originalItems.filter(
          (orig) => orig.stock_id && !currentItems.some((curr) => curr.stock_id === orig.stock_id)
        )
        const changed = currentItems
          .filter((curr) => curr.stock_id)
          .map((curr) => {
            const orig = originalItems.find(
              (o) => o.stock_id === curr.stock_id
            )
            if (!orig) return null

            const newPhotos = getNewPhotos(curr.fotos, orig.fotos)

            const hasOtherChanges =
              curr.checked !== orig.checked ||
              curr.calidad !== orig.calidad ||
              curr.update_estacion_cero !== orig.update_estacion_cero

            if (hasOtherChanges || newPhotos.length > 0) {
              return {
                ...curr,
                fotos: newPhotos, 
              }
            }

            return null
          })
          .filter(Boolean)

        const modifiedItems = [...added, ...removed, ...changed]

        if (modifiedItems.length > 0) {
          return { ...p, items: modifiedItems }
        }

        return null
      })
      .filter(Boolean) 

    const filtered = [...newProductsToCreate, ...previouslyCheckedNowUnselected, ...modifiedProducts]
    const productosSinItemsOriginal = filtered.map(({ itemsOriginal, ...rest }) => rest)

    const values = {
      productos: productosSinItemsOriginal,
      color: initValues.vehicle.color,
      transmision: initValues.vehicle.transmision,
      traccion: initValues.vehicle.traccion,
      combustible: initValues.vehicle.combustible,
      puertas: initValues.vehicle.puertas,
      kms: parseInt(initValues.vehicle.kms.toString().replace(/\./g, "")),
      tipo_siniestro: initValues.vehicle.tipo_siniestro,
      observaciones_estacion_cero: initValues.vehicle.observaciones_estacion_cero,
    }
    return await interfaces.plantStation
      .createStock(initValues.vehicle.id, values)
      .then(async (res) => {
        createDismissableSnackbar("Ingreso de vehículo finalizado!", {
          variant: "success",
        })
        // for (let i = 0; i < res.data.products.length; i++) {
        //   await handleUploadImg(
        //     res.data.products[i].empresa,
        //     res.data.products[i].codigo,
        //     initValues.products.find(
        //       (e) => e.id === res.data.products[i].producto_id
        //     ).fotos
        //   )
        // }
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: "error",
        })
      })
  }

  async function handleSubmitCode() {
    setLoadingSearch(true)
    await interfaces.plantStation
      .searchVehicle(code.code)
      .then((res) => {
        if (res.data.alert) {
          setWarning(true)
        }
        setInitValues({
          ...initValues,
          vehicle: res.data.vehicle,
          products: res.data.products.map((item) => ({
            ...item,
            itemsOriginal: item.items ? [...item.items] : [],
            items: item.items?.length
              ? item.items
              : [],
            checked: item.checked || false,
          })),
          calidades: res.data.calidades,
          originalVehicle: { ...res.data }
        })
        setProductsCheck(
          res.data.products
            .filter((item) => item.checked === true)
            .map((item) => item.id)
        )
        setProductsWithOutCheck(
          res.data.products
            .filter((item) => item.checked !== true)
            .map((item) => item.id)
        )
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: "error",
        })
      })
    setLoadingSearch(false)
  }

  const handleChangeCode = (e) => {
    setCode({ ...code, code: e.target.value.toUpperCase() })
  }

  async function handleSubmit() {
    if (tab === 3) {
      setTab(tab + 1)
      await handleCreateStock()
      handleclose()
      setRender(!render)
    } else {
      setTab(tab + 1)
    }
  }

  function handlePrev() {
    if (tab !== 0) {
      setTab(tab - 1)
    } else {
      handleclose()
    }
  }

  function disabledSubmit() {
    switch (tab) {
      case 0:
        return initValues.vehicle && initValues.products.length > 0
          ? false
          : true
      case 1:
        return initValues.vehicle.color &&
          initValues.vehicle.puertas &&
          initValues.vehicle.combustible &&
          initValues.vehicle.transmision &&
          initValues.vehicle.tipo_siniestro &&
          initValues.vehicle.traccion
          ? false
          : true
      case 2: {
        const checkedProducts = initValues.products.filter((p) => p.checked)
        const previouslyCheckedNowUnchecked = initValues.products.some(
          (p) => productsCheck.includes(p.id) && !p.checked
        )

        if (previouslyCheckedNowUnchecked) return false

        if (checkedProducts.length === 0) return true

      const allHaveCheckedItems = checkedProducts.every((product) => {
        if (!Array.isArray(product.items)) return true
        if (product.items.length === 0) return false

        const hasCheckedItems = product.items.some((item) => item.checked)
        if (
          !hasCheckedItems &&
          product.items.some(
            (item) =>
              item.estado === "Colocado" &&
              item.stock_id &&
              item.checked === false
          )
        ) {
          return true
        }

        const allItemsInPapelera = product.items.every((item) => item.estado === "Papelera" && item.checked === false)
          if (!hasCheckedItems && allItemsInPapelera) { 
          return true  
        }

        return hasCheckedItems
      })

      return !allHaveCheckedItems
      }
      case 3: {
        const vehicle = initValues?.vehicle
        const originalVehicle = initValues?.originalVehicle?.vehicle
        const products = initValues.products || []

        if (!vehicle || !originalVehicle) return true 

        const hasNoChanges = Object.keys(originalVehicle).every((key) => {
          const v1 = vehicle[key]
          const v2 = originalVehicle[key]
          return typeof v1 === "string" && typeof v2 === "string"
            ? v1.trim().toLowerCase() === v2.trim().toLowerCase()
            : v1 === v2
        })

        const hasNoChangesProducts = products.every((product) => {
          const currentItems = product.items || []
          const originalItems = product.itemsOriginal || []

          if (currentItems.length !== originalItems.length) return false

          const sameItems = currentItems.every((item) => {
            const originalItem = originalItems.find(
              (o) => o.stock_id === item.stock_id
            )
            if (!originalItem) return false

            return (
              item.calidad === originalItem.calidad &&
              item.empresa === originalItem.empresa &&
              item.checked === originalItem.checked &&
              item.update_estacion_cero === originalItem.update_estacion_cero &&
              JSON.stringify(item.fotos || []) === JSON.stringify(originalItem.fotos || [])
            )
          })

          return sameItems
        })

        return hasNoChanges && hasNoChangesProducts
      }
      case 4: 
        return true
      default:
        break
    }
  }

  return (
    <>
      <DialogComponent
        open={open}
        handleclose={tab === 5 ? null : () => handleclose({ code: "" })}
        tabs={horizontalTabs}
        widthLarge="600px"
        title="Ingreso vehículo a planta "
        maxHeight
        disableBackdropClick={step > 0 ? true : false}
        disableEscapeKeyDown={step > 0 ? true : false}
        children={
          <>
            <Stepper
              alternativeLabel
              activeStep={tab}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0,
                paddingBottom: 20,
              }}
            >
              {steps
                .filter((e) => e !== "")
                .map((label, index) => (
                  <Step key={index}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
            </Stepper>
            <div style={{ height: "555px" }}>{_renderForms(tab)}</div>
          </>
        }
        actions={
          <CancelConfirmButtons
            onClickSubmit={handleSubmit}
            onClickCancel={handlePrev}
            submitText={tab === 3 ? "Confirmar" : "Siguiente"}
            cancelText={tab === 0 ? "Cancelar" : "Atrás"}
            disabledSubmit={!initValues.vehicle ? true : initValues.products.filter((p) => p.checked).length > 0 ? disabledSubmit() : false} 
            disabledCancel={tab >= 4} 
          />
        }
      />
    </>
  )
}

export default NewStation
